
import { ConfigBucketStorage } from "@/feature-flags/flags-config-bucket-storage";
import { prop, Vue } from "vue-class-component";
import { AccountController } from '@/app/ui/controllers/AccountController';

class Props {
  type = prop<string>({
    default: "",
    type: String
  });
}

export default class BannerProductType extends Vue.with(Props) {
  get accountIsNonForeign() {
    return !AccountController.accountData.accountIsForeign;
  }
  get insuranceRetailFileName() {
    if (this.accountIsNonForeign) return "banner-insurance-retail-revamp.svg"
    return "banner-insurance-retail-revamp-en.svg"
  }

  get bannerFileLink(): string {
    const baseUrl = ConfigBucketStorage.config_bucket_prd_genesis.getValue();
    let fileName: string;

    switch (this.type) {
      case "insurance-retail":
        fileName = this.insuranceRetailFileName;
        break;
      case "insurance-client":
        fileName = "banner-insurance-client-revamp.svg";
        break;
      case "shipment":
        fileName = "banner-product-type-revamp.png";
        break;
      default:
        fileName = "";
        break;
    }
    return `${baseUrl}/${fileName}`;
  }
}
